import BasicForm from './BasicForm';

/**
 * @description Order tracking form customizations
 */
export default class OrderTrack extends BasicForm {

    submitOrderTrack(el, event) {
        event.preventDefault();

        var form = this.ref('self').get();
        if (form) {
            var email = form.querySelector('input[name="trackOrderEmail"]');
            var emailVal = email ? email.value : '';
            var order = form.querySelector('input[name="trackOrderNumber"]');
            var orderVal = order ? order.value : '';
            var token = form.querySelector('input[type="hidden"]');
            var tokenVal = token ? token.value : '';
            window.location.href = form.action + '?trackOrderNumber=' + orderVal + '&trackOrderEmail=' + window.btoa(emailVal) + '&csrf_token=' + tokenVal + '&submit=submit';
        }
    }
}